@import 'styles/variables';
@import 'styles/mixins';

.items {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.itemLink {
  text-decoration: none;
  color: inherit;
  display: block;
}

.item {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 10px 12px;
  border-radius: 10px;
  cursor: pointer;
  transition: filter 0.2s ease;

  &:hover {
    filter: brightness(0.97);
  }
}

.icon {
  display: flex;
  flex-shrink: 0;
}

.itemLabel {
  flex: 1;
  min-width: 0;
}
